export const DownArrow = () => (
    <svg
        className="dropdown"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.21191 7.60602L9.99991 12.394L14.7879 7.60602"
            stroke="#6C7084"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
